var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLanguageChange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0645 17.6761L15.9265 13.4116L13.7898 17.6761",
    stroke: "#1B3F67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1794 16.917H17.6951",
    stroke: "#1B3F67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9265 21.0012C14.9231 21.0012 13.9422 20.7036 13.1078 20.1461C12.2735 19.5887 11.6232 18.7963 11.2392 17.8692C10.8552 16.9422 10.7548 15.9221 10.9505 14.9379C11.1463 13.9538 11.6295 13.0498 12.339 12.3402C13.0485 11.6307 13.9525 11.1475 14.9367 10.9517C15.9209 10.756 16.941 10.8564 17.868 11.2404C18.7951 11.6244 19.5874 12.2747 20.1449 13.109C20.7024 13.9434 20.9999 14.9243 20.9999 15.9277C20.9999 17.2733 20.4654 18.5637 19.514 19.5152C18.5625 20.4666 17.2721 21.0012 15.9265 21.0012V21.0012Z",
    stroke: "#1B3F67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04285 1.02819H7.95721C10.0249 1.02819 11.0243 2.02627 10.9732 4.04415V7.95851C11.05 8.37134 11.0251 8.79667 10.9007 9.19774C10.7763 9.59881 10.5561 9.96357 10.2592 10.2605C9.96227 10.5574 9.59752 10.7776 9.19645 10.902C8.79538 11.0264 8.37005 11.0513 7.95721 10.9745H4.04285C2.02497 11.0154 1.02689 10.016 1.02689 7.94828V4.03393C0.968215 3.62466 1.00586 3.20734 1.13684 2.81518C1.26782 2.42303 1.48852 2.06685 1.78137 1.77499C2.07422 1.48313 2.43114 1.26365 2.82375 1.134C3.21635 1.00435 3.63379 0.968121 4.04285 1.02819V1.02819Z",
    stroke: "#1B3F67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02747 4.87354H3.97253",
    stroke: "#1B3F67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99048 4.1936V4.87092",
    stroke: "#1B3F67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00775 4.86328C7.02248 5.68654 6.71018 6.48206 6.13932 7.07544C5.56846 7.66881 4.78562 8.01164 3.9624 8.02876",
    stroke: "#1B3F67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0276 8.02881C7.66191 8.01829 7.30389 7.92146 6.98274 7.74623C6.6616 7.571 6.38643 7.32233 6.17969 7.02051",
    stroke: "#1B3F67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02686 14.011C1.02619 14.9292 1.20654 15.8385 1.5576 16.6869C1.90866 17.5353 2.42354 18.3062 3.07279 18.9554C3.72204 19.6047 4.49292 20.1196 5.34134 20.4706C6.18976 20.8217 7.09906 21.002 8.01724 21.0014L6.96932 19.2506",
    stroke: "#1B3F67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.01846C21.0007 7.10028 20.8203 6.19098 20.4693 5.34256C20.1182 4.49415 19.6033 3.72326 18.9541 3.07401C18.3048 2.42476 17.534 1.90988 16.6855 1.55882C15.8371 1.20776 14.9278 1.02741 14.0096 1.02808L15.0588 2.77631",
    stroke: "#1B3F67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageChange);
export default __webpack_public_path__ + "static/media/language-change.f2358071eb94d711eb31b873cf923f7f.svg";
export { ForwardRef as ReactComponent };